import { render, staticRenderFns } from "./active-words-modal.vue?vue&type=template&id=2a391868&"
import script from "./active-words-modal.vue?vue&type=script&lang=js&"
export * from "./active-words-modal.vue?vue&type=script&lang=js&"
import style0 from "./active-words-modal.vue?vue&type=style&index=0&id=2a391868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports